
import { useDispatch } from 'react-redux';
import store from '../store';

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

// eslint-disable-next-line no-unused-vars
export type AnyFunction = (arg: any) => void
